module.exports = __webpack_public_path__ + "img/pencil-outline.4df25439.svg";